module.exports = __webpack_public_path__ + "img/intro.43d1c283.webp";